module.exports = __webpack_public_path__ + "img/search-null.f1b96321.png";